import * as styles from "./MonthPickerContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";
import { pointerAlignOffset } from "@frontend/utils/pointerAlign";

import { useMonthPickerContext } from "./MonthPicker.context";
import type { MonthPickerContentProps } from "./MonthPicker.types";
import { MonthPickerArrow } from "./MonthPickerArrow";
import { MonthPickerBackdrop } from "./MonthPickerBackdrop";
import { MonthPickerGrid } from "./MonthPickerGrid";
import { MonthPickerHeader } from "./MonthPickerHeader";
import { MonthPickerPortal } from "./MonthPickerPortal";
import { ARROW_SIZES } from "./constants";

const GAP = 4;

export function MonthPickerContent({
  className,
  side = "bottom",
  sideOffset,
  align = "center",
  alignOffset,
  positionMethod,
  ...props
}: MonthPickerContentProps): JSX.Element {
  const { arrow, size, pointerOffsetRef } = useMonthPickerContext();

  return (
    <MonthPickerPortal>
      <MonthPickerBackdrop />
      <BasePopover.Positioner
        data-slot="month-picker-positioner"
        side={side}
        sideOffset={sideOffset ?? (arrow ? ARROW_SIZES[size] : GAP)}
        align={align}
        alignOffset={alignOffset ?? pointerAlignOffset(pointerOffsetRef, arrow)}
        positionMethod={positionMethod}
        className={styles.positioner}
      >
        <BasePopover.Popup
          data-slot="month-picker-popup"
          className={clsx(styles.popup, className)}
          {...props}
        >
          {arrow && <MonthPickerArrow />}
          <MonthPickerHeader />
          <MonthPickerGrid />
        </BasePopover.Popup>
      </BasePopover.Positioner>
    </MonthPickerPortal>
  );
}
